import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ActionButton } from '@augmentt-dev/ui-components'
import { ACTIONS } from '../../IntegrationModals'

function EmployeeActionsSection(props) {
  const { isAuthorized, openIntegrationModal, selectedEmployees, overrideEngageLicensing = false } = props

  const m365Buttons = [
    {
      action: ACTIONS.RESET_PASSWORD,
      messageId: 'ENGAGE.RESET_PASSWORD',
      icon: 'fas fa-key',
      exclude: selectedEmployees.length > 1,
    },
    {
      action: ACTIONS.BLOCK_SIGNIN,
      messageId: 'ENGAGE.BLOCK_SIGNIN',
      icon: 'fas fa-ban',
      exclude: selectedEmployees.every((emp) => !emp.enabled),
    },
    {
      action: ACTIONS.UNBLOCK_SIGNIN,
      messageId: 'ENGAGE.UNBLOCK_SIGNIN',
      icon: 'far fa-circle-check',
      exclude: selectedEmployees.every((emp) => emp.enabled),
    },
    {
      action: ACTIONS.SIGNOUT_OF_ALL_APPS,
      messageId: 'ENGAGE.SIGN_OUT_ALL_APPS',
      icon: 'fas fa-right-from-bracket',
      exclude: selectedEmployees.length > 1,
    },
  ]

  const isAuthorizedForEngage = selectedEmployees.every((emp) => emp.isAuthorizedForEngage)

  return m365Buttons
    .filter((button) => !button.exclude)
    .map((button) => (
      <ActionButton
        key={button.messageId}
        icon={button.icon}
        label={<FormattedMessage id={button.messageId} />}
        disabled={!(isAuthorized && (isAuthorizedForEngage || overrideEngageLicensing))}
        onClick={() => openIntegrationModal(button.action)}
      />
    ))
}

export default EmployeeActionsSection
